import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useAppDispatch } from "@/hooks/store";
import { useGetCurrentUserQuery } from "@/store/api";
import { setCurrentUser, setPreferences } from "@/store/authSlice";
import { useOutlet } from "react-router";
/**
 * Affichage du contenu principal de la page
 * @returns
 */
export default function ApplicationPage() {
    var _a, _b, _c, _d;
    var outlet = useOutlet();
    var dispatch = useAppDispatch();
    var _e = useGetCurrentUserQuery(null), userResponse = _e.data, isLoading = _e.isLoading, isError = _e.isError, isFetching = _e.isFetching;
    if ((_a = userResponse === null || userResponse === void 0 ? void 0 : userResponse.data) === null || _a === void 0 ? void 0 : _a.record) {
        dispatch(setCurrentUser((_b = userResponse === null || userResponse === void 0 ? void 0 : userResponse.data) === null || _b === void 0 ? void 0 : _b.record));
    }
    if ((_c = userResponse === null || userResponse === void 0 ? void 0 : userResponse.data) === null || _c === void 0 ? void 0 : _c.preferences) {
        dispatch(setPreferences((_d = userResponse === null || userResponse === void 0 ? void 0 : userResponse.data) === null || _d === void 0 ? void 0 : _d.preferences));
    }
    return _jsx(_Fragment, { children: outlet });
}
